import './HeroSection.css';
import doctorMale from '../assets/males.png';
import doctorFemale from '../assets/femaless.png';
import { useNavigate } from 'react-router-dom';
import Blogs from '../components/Pages/Blogs';

const HeroSection = () => {
    const navigate = useNavigate();

    const handleEnrollClick = () => {
        navigate('/imat-course'); // Use navigate instead of window.location.href
    };

    return (
        <>
            <section className="hero">
                <div className="hero-text">
                    <h1>Welcome To Future MedsAcademy</h1>
                    <p>
                        "Crack your goals with expert guidance and top-quality education.
                        Unlock your full potential through strategic learning. Empower yourself
                        with the skills and knowledge needed to succeed and achieve excellence."
                    </p>
                    <div className="nav-button">
                        <button className="btn" id="registerBtn" onClick={handleEnrollClick}>
                            Enroll Now
                        </button>
                        <button
                            className="btn"
                            id="loginBtn"
                            onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/login')}
                        >
                        Student Login
                        </button>
                    </div>
                </div>
            </section>
            <Blogs />
        </>
    );
};

export default HeroSection;